import {
    animate,
    state,
    style,
    transition,
    trigger
} from '@angular/animations';
import {
    AfterViewInit,
    Component,
    Input,
    OnDestroy,
    OnInit
} from '@angular/core';
import { select, Store } from '@ngrx/store';
import { StateService } from '@uirouter/core';
import { Observable, Subscription, combineLatest } from 'rxjs';
import { distinctUntilKeyChanged, map, takeWhile } from 'rxjs/operators';
import * as fromAuth from '../../../app/auth/store/auth.reducer';
import * as fromUser from '../../../app/user-info/store/user.reducer';
import { environment } from '../../../environments/environment';
import { AppComponent } from '../../app.component';
import * as fromShared from '../../shared';
import { Process } from '../../shared';
import { Category } from '../../shared/category/category.model';
import { EfaactPrimeNGModule, MenuItem } from '../../shared/efaact-primeng.module';
import { LoggingService } from '../../shared/services/logging/logging.service';
import * as fromSettings from '../../../app/company-setting';
import * as fromUserSetting from '../../../app/user-setting/store';
import { IUser } from '../../user-info';
import { SharedModule } from '../../shared/shared.module';
import { MenuService } from '../service/menu.service';
import { MessageStateService } from '../../shared/services/message-state.service';

@Component({
    selector: 'app-message',
    animations: [
        trigger('children', [
            state(
                'hiddenAnimated',
                style({
                    height: '0px'
                })
            ),
            state(
                'visibleAnimated',
                style({
                    height: '*'
                })
            ),
            state(
                'visible',
                style({
                    display: 'block'
                })
            ),
            state(
                'hidden',
                style({
                    display: 'none'
                })
            ),
            transition(
                'visibleAnimated => hiddenAnimated',
                animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')
            ),
            transition(
                'hiddenAnimated => visibleAnimated',
                animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')
            )
        ])
    ],
    templateUrl: './app.message.html',
    styleUrls: ['./app.message.scss'],
    standalone: true,
    imports: [SharedModule]
})
export class AppMessage {
    public MessageStyle = {
        'margin-top': '4rem',
        'margin-left': '4.9rem',
        'background-color': '#f2f2f2',
        width: '30%'
    };
    public companySettings$: Observable<fromSettings.CompanySetting[]>;
    public userSettings$: Observable<Array<fromUserSetting.UserSetting>>;
    public userMsg;
    public mgrMsg;
    public adminMsg;
    messages: any[] = [];
    active = true;
    userMsgPushed = false;
    mgrMsgPushed = false;
    adminMsgPushed = false;
    showMsg: boolean;

    // Use getter for reactive binding to the service
    get markAsReadCheckbox(): boolean {
        return this.messageStateService.markAsRead;
    }

    user: IUser;
    private settingsSubscription: Subscription;
    constructor(
        public app: AppComponent,
        public menuService: MenuService,
        private store: Store<fromUser.State>,
        public messageStateService: MessageStateService
    ) {
        this.store
            .pipe(
                select(fromUser.getUserInfo),
                takeWhile(() => this.active),
            )
            .subscribe(userInfo => {
                this.store.dispatch(
                    fromUserSetting.getUserSettings({
                        EmployeeListID: userInfo.EmployeeListID,
                        EmpSettingID: 31
                    })
                );

                if (userInfo.DefaultRoleGroupID == 1) {
                    this.store.dispatch(
                        fromSettings.getCompanySetting({
                            SettingType: 'AdminMsg1'
                        })
                    );

                    this.store.dispatch(
                        fromSettings.getCompanySetting({
                            SettingType: 'MgrMsg1'
                        })
                    );

                    this.store.dispatch(
                        fromSettings.getCompanySetting({
                            SettingType: 'UserMsg1'
                        })
                    );
                } else if (
                    userInfo.DefaultRoleGroupID == 12024 ||
                    userInfo.DefaultRoleGroupID == 12025
                ) {
                    this.store.dispatch(
                        fromSettings.getCompanySetting({
                            SettingType: 'MgrMsg1'
                        })
                    );

                    this.store.dispatch(
                        fromSettings.getCompanySetting({
                            SettingType: 'UserMsg1'
                        })
                    );
                } else {
                    this.store.dispatch(
                        fromSettings.getCompanySetting({
                            SettingType: 'UserMsg1'
                        })
                    );
                }
            });
        this.userSettings$ = this.store.pipe(select(fromUserSetting.selectAll));
        this.companySettings$ = this.store.pipe(select(fromSettings.selectAll));

        // Subscribe to company settings to load message content
        this.settingsSubscription = this.companySettings$
            .pipe(takeWhile(_ => this.active))
            .subscribe(settings => {
                this.userMsg =
                    settings.find(x => x.SettingType == 'UserMsg1') != null
                        ? settings.find(x => x.SettingType == 'UserMsg1')
                              .SettingValue
                        : null;
                this.mgrMsg =
                    settings.find(x => x.SettingType == 'MgrMsg1') != null
                        ? settings.find(x => x.SettingType == 'MgrMsg1')
                              .SettingValue
                        : null;
                this.adminMsg =
                    settings.find(x => x.SettingType == 'AdminMsg1') != null
                        ? settings.find(x => x.SettingType == 'AdminMsg1')
                              .SettingValue
                        : null;

                if (this.userMsg != null && this.userMsg != '') {
                    if (this.userMsgPushed == false) {
                        this.messages.push(this.userMsg);
                        this.userMsgPushed = true;
                    }
                }
                if (this.mgrMsg != null && this.mgrMsg != '') {
                    if (this.mgrMsgPushed == false) {
                        this.messages.push(this.mgrMsg);
                        this.mgrMsgPushed = true;
                    }
                }
                if (this.adminMsg != null && this.adminMsg != '') {
                    if (this.adminMsgPushed == false) {
                        this.messages.push(this.adminMsg);
                        this.adminMsgPushed = true;
                    }
                }

                // Update the message count in the service
                this.messageStateService?.setMessageCount(this.messages.length);
            });
    }

    onMarkAsRead(markAsReadChecked, listid) {
        // Use the message state service to update the setting
        this.messageStateService.setMarkAsRead(markAsReadChecked, listid);
    }

    ngOnDestroy() {
        this.active = false;
    }
}
